export default "__VITE_ASSET__CtZdGP_V__"